import {InjectionToken} from '@angular/core';
import {AppConfig, AppConfigFactory} from './app-config';
export {AppConfig, AppConfigFactory};
export let APP_CONFIG = new InjectionToken<AppConfig>('app.config');
